export default "__VITE_ASSET__DTy_d4PR__"